import { BarColor } from 'components/cell-percent-bar/BarColor';
import { renderLitresToHL } from 'components/global/utils';
import { valueExist } from '@utils/typescriptGuards';


interface CellPercentBarProps {
	cellClassName: string,
	value: number,
	percentValue: number | undefined | null,
	color?: BarColor,
}
  

const CellPercentBar = (props: CellPercentBarProps) => {
	const { cellClassName, value, percentValue, color } = props;

	const renderValue = value ? renderLitresToHL(value) : '0';

	return (
		<div className={`components-cell-percent-bar ${cellClassName}`}>
			{valueExist(percentValue) && percentValue > 0 && !renderValue.startsWith('0') &&
				<div className={`percent-bar${color && color !== BarColor.main ? ` percent-bar-color-${color}` : ''}`} style={{ width: `${percentValue}%` }}></div>}
			<p>{renderValue}</p>
		</div>
	)
}

export default CellPercentBar;